<common-footer-control
  #myFooter
  [footerLinks]="dataFooterLinks"
  [topBorder]="true"
></common-footer-control>
